import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, Box } from '@mui/material';
var Settings = function () {
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "h4", children: "Settings" }), _jsx(Typography, { children: "Configure your account and application settings" })] }));
};
export default Settings;
